<template>
  <div class="component-body">
    <div class="margin-top-8 flex">
      <el-checkbox v-model="checked">备选项</el-checkbox>
      <el-checkbox v-model="checked" disabled>备选项1</el-checkbox>
    </div>
    <div class="margin-top-8 flex">
      <el-checkbox-group v-model="checkboxGroup1">
        <el-checkbox-button v-for="city in cities" :label="city" :value="city" :key="city">{{ city }}</el-checkbox-button>
      </el-checkbox-group>
      <el-checkbox-group v-model="checkboxGroup1" disabled class="margin-left-10">
        <el-checkbox-button v-for="city in cities" :label="city" :value="city" :key="city">{{ city }}</el-checkbox-button>
      </el-checkbox-group>
    </div>
    <div class="margin-top-8 flex">
      <el-checkbox v-model="checked1" label="备选项1" border></el-checkbox>
      <el-checkbox v-model="checked1" label="备选项1" border disabled></el-checkbox>
    </div>
  </div>
</template>

<script>
const cityOptions = ['上海', '北京', '广州', '深圳']
export default {
  name: 'index',
  data () {
    return {
      checked: true,
      checkboxGroup1: ['上海'],
      cities: cityOptions,
      checked1: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/5/Checkbox/index.vue